import { useLazyQuery } from '@apollo/client/react';
import styled from '@emotion/styled';
import { css } from '@styled-system/css';
import Router from 'next/router';
import React, { useEffect } from 'react';

import { Box, EntryList, Loader } from '~/components/blocks';
import { GetOrganizationSettingsBankAccountDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { usePractitionerRole } from '~/hooks/use-practitioner-role';
import { Label } from '~/utils/label';

const Root = styled(Box)(() =>
  css({
    position: 'relative',
    height: '100%',
    overflow: 'auto',
  }),
);

export const BankAccount = () => {
  const [getOrganizationSettingsBankAccount, { data, loading }] = useLazyQuery(
    GetOrganizationSettingsBankAccountDocument,
    {
      fetchPolicy: 'network-only',
    },
  );
  const { verifyRole, loadingRole } = usePractitionerRole();
  const hasViewingBankAccountAuthority = verifyRole(['company_admin', 'admin']);
  const bankAccount = data ? getMe(data)?.organization.bankAccount : null;

  useEffect(() => {
    if (hasViewingBankAccountAuthority) {
      getOrganizationSettingsBankAccount();
    }
  }, [getOrganizationSettingsBankAccount, hasViewingBankAccountAuthority]);

  if (!loadingRole && !hasViewingBankAccountAuthority) {
    Router.push('/');
  }

  return (
    <Root>
      {loading ? (
        <Loader open inside />
      ) : (
        <>
          <EntryList>
            <EntryList.Head>銀行名</EntryList.Head>
            <EntryList.Body>{bankAccount?.bankName || '未登録'}</EntryList.Body>
          </EntryList>
          <EntryList>
            <EntryList.Head>支店名</EntryList.Head>
            <EntryList.Body>{bankAccount?.branchName || '未登録'}</EntryList.Body>
          </EntryList>
          <EntryList>
            <EntryList.Head>口座種別</EntryList.Head>
            <EntryList.Body>
              {bankAccount?.accountType ? Label.bankAccountType(bankAccount.accountType) : '未登録'}
            </EntryList.Body>
          </EntryList>
          <EntryList>
            <EntryList.Head>口座番号</EntryList.Head>
            <EntryList.Body>{bankAccount?.accountNumber || '未登録'}</EntryList.Body>
          </EntryList>
          <EntryList>
            <EntryList.Head>口座名義</EntryList.Head>
            <EntryList.Body>{bankAccount?.accountHolderName || '未登録'}</EntryList.Body>
          </EntryList>
        </>
      )}
    </Root>
  );
};
